import gql from "graphql-tag";

export const SUBSCRIBE_ALL_SCHEMES1 = gql`
    subscription($orgId:uuid!,$endTime:date!,$startTime:date!){
        Scheme(where: {isArchieved: {_eq: false},isSpecialScheme:{_eq: false},endTime:{_gte:$endTime},startTime:{_lte:$startTime}}){
            id
            name
            description
            backgroundImage
            schemeProductPoints {
                Product {        name      }
                points
                quantity
            }
            SchemeEnrollments(where: {partnerId: {_eq: $orgId}}){
                id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId isVerified
                redemPoint redemptioInProgress transferPoints  partnerId adjustment returnOrderPoint
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            criteria
            pointMethod
            points
        }
    }`

export const SUBSCRIBE_SCHEME_POINTS = gql`
    subscription SchemeEnrollment($schemeId:uuid!,$partnerId:uuid!){
        SchemePoints:SchemeEnrollment(where: {schemeId: {_eq:$schemeId},partnerId:{_eq:$partnerId}}) {
            id
            earnPoint
            eligiblePoint
            myTeamEarnPoint
            myTeamEligiblePoint
            schemeId
            redemPoint
            redemptioInProgress
            transferPoints
            returnOrderPoint
        }
    }`

export const SUBSCRIBE_SCHEME_DETAIL_WITH_POINTS = gql`
    subscription Scheme($id:uuid!,$partnerId:uuid!){
        Scheme(where:{id:{_eq:$id}}){
            id
            name
            description
            backgroundImage
            SchemaPointView(order_by: {sequenceNumber: asc, productSequenceNumber: asc}){
                productname
                points
                quantity
            }
            SchemeEnrollments(where: {partnerId: {_eq: $partnerId}}){
                id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId
                redemPoint redemptioInProgress transferPoints adjustment returnOrderPoint
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            pointMethod
            points
            isAutoJoin
            goalPoints
            isSelfRedemption
            applicableOn
            minMonthlyPointsForEligible
            isMultiRedemptionAllowed
            isHerirachyScheme
            criteria
            isSpecialScheme
            canRedeemPointInCurrentGoal
        }
    }
`
